import { render, staticRenderFns } from "./NavigationBarMentor.vue?vue&type=template&id=5fddafa7&scoped=true&"
import script from "./NavigationBarMentor.vue?vue&type=script&lang=js&"
export * from "./NavigationBarMentor.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarMentor.vue?vue&type=style&index=0&id=5fddafa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fddafa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon})
